import React, { useState } from 'react';
import styled from 'styled-components';
import caller_id_icon from './caller-id-icon.svg';
import CallerIdHistoryModal from './CallerIdHistoryModal';
import { IApiHistoryCallerIdParams } from 'services/types/caller';
import moment from 'moment';
import apis from 'services/apis';
import { AxiosResponse } from 'axios';
import { ICallerIdHistoryResItem, IUICallerIdHistoryItem } from 'types/customer';
import { maskPhone } from 'utils/formatPhone';
const DATE_FORMAT = 'MM-DD-YYYY';

const CallerIdHistory = () => {
  const [open, setOpen] = useState(false);
  const [params, setParams] = useState<IApiHistoryCallerIdParams>({
    startDate: moment().format(DATE_FORMAT),
    endDate: moment().format(DATE_FORMAT),
    page: 1,
  });
  const [dataSource, setDataSource] = useState<IUICallerIdHistoryItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);

  const onFilter = (_params: Partial<IApiHistoryCallerIdParams>) => {
    const newParams: IApiHistoryCallerIdParams = {
      endDate: _params?.endDate || moment().format(DATE_FORMAT),
      startDate: _params.startDate || moment().format(DATE_FORMAT),
      page: 1,
    };
    fetchData(newParams);
  };

  const fetchData = async (params: IApiHistoryCallerIdParams) => {
    setParams(params);
    setLoading(true);
    try {
      const res: AxiosResponse<{ payload: { data: ICallerIdHistoryResItem[], total: number } }> = await apis.historyCallerId(params);
      if (res.data.payload) {
        setDataSource(res.data.payload.data.map(o => ({
          name: o.customerName || 'Unknown Customer',
          phone: o.customerPhone ? maskPhone(o.customerPhone) : '--',
          customerType: o.customerType?.toLowerCase() === 'regular' ? 'regular' : 'new',
          date: o.date || 'Unknown Date',
          time: o.time || 'Unknown Time',
        })));
        setTotalItems(res.data.payload.total);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const onOpen = async () => {
    setOpen(true);
    const _params: IApiHistoryCallerIdParams = {
      startDate: moment().format(DATE_FORMAT),
      endDate: moment().format(DATE_FORMAT),
      page: 1,
    };
    fetchData(_params);
  };

  const onClose = () => {
    setOpen(false);
  };

  const onChangePage = (page: number) => {
    const newParams: IApiHistoryCallerIdParams = {
      ...params,
      page,
    };
    fetchData(newParams);
  };

  return (
    <>
      <ButtonCaller type='button' onClick={onOpen}>
        <img src={caller_id_icon} alt="caller_id_icon" style={{ width: 32, height: 32 }} />
        <span>Caller ID</span>
      </ButtonCaller>
      <CallerIdHistoryModal visible={open} onClose={onClose}
        dataSource={dataSource}
        params={params}
        onChange={onFilter}
        loading={loading}
        totalItems={totalItems}
        onChangePage={onChangePage}
      />
    </>
  );
};

export default CallerIdHistory;

const ButtonCaller = styled.button`
display: flex;
height: 48px;
padding: 0 16px;
margin-left: 8px;
justify-content: center;
align-items: center;
gap: 4px;
border-radius: 4px;
background: #F05326;

&:hover {
  cursor: pointer;
}
&:active {
  opacity: 0.5;
}

span {
  color: #FFF;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
`;
